import { type DomainRouteName } from 'domains/catalog-admin/routing/routes'
import {
  domainRedirectComponentFactory,
  domainRouteComponentFactory,
} from 'utils/core/factories/routing/routingComponents.factories'
import { type DomainAccessControlConfig } from 'domains/catalog-admin/utils/domain/accessControl'

export const DomainRoute = domainRouteComponentFactory<DomainRouteName, DomainAccessControlConfig>()
export const DomainRedirect = domainRedirectComponentFactory<
  DomainRouteName,
  DomainAccessControlConfig
>()
